<template>
	<section class="deep-donate-view">
		<link rel="stylesheet" href="https://use.typekit.net/rhi6acd.css" />
		<div class="deep-register-parts" v-if="institution">
			<div class="deep-register-emotion">
				<div class="register-images">
					<img class="cover" @error="downgradeImage" :src="image" />
					<img class="logo" :src="institution.logo_url" />
				</div>
				<h1>{{ institution.impact_statement }}</h1>
				<p>
					Your donations allow us to
					{{ institution.full_impact_statement }}.
				</p>
				<p v-if="institution.signup_cta">
					<strong
						>{{ institution.signup_cta }} How much would you like to
						give?</strong
					>
				</p>
				<p v-else>
					<strong> How much would you like to give?</strong>
				</p>
				<form v-on:submit.prevent="onSubmit" class="register-form">
					<div class="donate">
						<div
							:class="[
								'section',
								current == 0 ? 'active' : 'inactive'
							]"
						>
							<segment-toggle
								:value="gift"
								:options="options"
								@on-change="setGift"
								name="donate"
								labelPrefix="$"
							/>
							<label
								v-if="gift === 'custom'"
								:style="{ marginTop: '15px', margin: 'auto' }"
							>
								<p :style="{ marginBottom: '5px' }">
									Look at you making an impact! Enter your
									gift below:
								</p>
								<ui-input
									v-model="custom_gift"
									placeholder="$100"
									native-type="number"
									:style="{ width: '50%', display: 'block' }"
									type="blue"
								/>
							</label>
							<v-row>
								<Roundup-Button
									@click="next()"
									v-if="!isLoggedIn"
									color="primary"
									style="
										width: 50%;
										margin: auto !important;
										margin-top: 40px !important;
									"
									>Next</Roundup-Button
								>
								<Roundup-Button
									@click="onDonateNow()"
									v-else
									:loading="isLoading"
									style="
										width: 50%;
										margin: auto !important;
										margin-top: 40px !important;
									"
									color="primary"
									>Donate Now
								</Roundup-Button>
							</v-row>
							<div class="powered-by-logo">
								<p
									:style="{
										height: '10px',
										display: 'inline'
									}"
								>
									Powered by
								</p>
								<img
									:style="{
										height: '10px',
										display: 'inline'
									}"
									src="../../assets/roundup_logo.svg"
								/>
							</div>
						</div>
						<div
							:class="[
								'section',
								current == 1 ? 'active' : 'inactive'
							]"
							:style="{ paddingBottom: '30px' }"
						>
							<div
								:style="{
									display: 'flex',
									flexDirections: 'row',
									justifyContent: 'space-between',
									flexWrap: 'wrap'
								}"
							>
								<label
									:style="{
										flex: 1,
										marginRight: '5px',
										minWidth: '150px',
										flexGrow: 1
									}"
								>
									<ui-input
										v-model="user.first_name"
										placeholder="First Name"
									/>
								</label>
								<label
									:style="{
										flex: 1,
										marginLeft: '5px',
										minWidth: '150px',
										flexGrow: 1
									}"
								>
									<ui-input
										v-model="user.last_name"
										placeholder="Last Name"
									/>
								</label>
							</div>
							<div
								:style="{
									display: 'flex',
									flexDirections: 'row',
									justifyContent: 'space-between',
									flexWrap: 'wrap'
								}"
							>
								<label
									:style="{
										flex: 1,
										marginRight: '5px',
										minWidth: '150px',
										flexGrow: 1
									}"
								>
									<p
										v-if="this.message"
										v-bind:style="{ fontSize: '12px' }"
									>
										{{ this.message }}
									</p>
									<ui-input
										v-model="user.phone"
										placeholder="Phone"
										@input="onlyNumber($event)"
									/>
								</label>
								<label
									:style="{
										flex: 1,
										marginLeft: '5px',
										minWidth: '150px',
										flexGrow: 1
									}"
								>
									<ui-input
										v-model="user.email"
										placeholder="Email"
									/>
								</label>
							</div>
							<label v-if="stripeMounted">
								<card
									class="stripe-card"
									:class="{ complete }"
									:stripe="stripe_token"
									:options="stripeOptions"
									@change="complete = $event.complete"
								/>
							</label>
							<div
								:style="{
									display: 'flex',
									flexDirections: 'row',
									justifyContent: 'space-around',
									flexWrap: 'wrap-reverse'
								}"
							>
								<label :style="{ display: 'flex' }">
									<Roundup-Button
										@click="back()"
										:disabled="isLoading"
										:style="{ background: '#71788C' }"
										color="white"
										>Back</Roundup-Button
									>
								</label>
								<label>
									<Roundup-Button
										:style="{
											paddingLeft: '50px',
											paddingRight: '50px'
										}"
										color="primary"
										type="submit"
										:loading="isLoading"
										>Donate
									</Roundup-Button>
								</label>
							</div>
							<p class="terms">
								By continuing, I confirm I am a U.S. resident,
								13 years or older and agree to the
								<a href="https://roundupapp.com/terms"
									>Terms of Use</a
								>.
							</p>
							<div class="powered-by-logo">
								<p
									:style="{
										height: '10px',
										display: 'inline'
									}"
								>
									Powered by
								</p>
								<img
									:style="{
										height: '10px',
										display: 'inline'
									}"
									src="../../assets/roundup_logo.svg"
								/>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div v-if="noInstitution">
			<div
				:style="{
					display: flex,
					alignItems: center,
					width: '100%',
					textAlign: 'center'
				}"
			>
				<h1>Hi There!</h1>
				<h2>You've hit a custom page that isn't live.</h2>
				<p>
					This is either because this page isn't ready yet for public
					view, OR the nonprofit is no longer a client. If you
					believed that you received this page in error, please email
					<a href="mailto:support@roundupapp.com"
						>support@roundupapp.com</a
					>.
				</p>

				<p>
					If you're a donor looking to sign up, please register here:
					<a href="https://app.roundupapp.com/#/Register"
						>app.roundupapp.com/register</a
					>
				</p>
			</div>
		</div>
	</section>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { loadScript, getUrlParams } from '../../utilities'
import { Card, createToken } from 'vue-stripe-elements-plus'
import UiButton from '../../ui/Button'
import UiInput from '../../ui/Input'
import SegmentToggle from '../../ui/SegmentToggle'

export default {
	name: 'deep-register-view',
	components: { UiInput, SegmentToggle, UiButton, Card },
	props: {
		uuid: String
	},
	data() {
		return {
			isLoading: false,
			noInstitution: false,
			complete: false,
			stripeOptions: {},
			message: '',
			user: {
				first_name: '',
				last_name: '',
				email: '',
				password: '',
				phone: '',
				institution: this.uuid
			},
			options: [5, 25, 50, 100, 'custom'],
			gift: 25,
			custom_gift: null,
			institution: null,
			current: 0,
			stripeMounted: false
		}
	},
	computed: {
		title() {
			if (!this.institution) {
				return false
			}
			return (
				'Support ' + this.institution.name + ' By Donating Your Change'
			)
		},
		description() {
			if (!this.institution) {
				return false
			}
			return (
				'Round up and donate your change to support ' +
				this.institution.name +
				'! Sign up in seconds to donate the change from your credit/debit card purchases so ' +
				this.institution.name +
				' can ' +
				this.institution.full_impact_statement +
				'.'
			)
		},
		image() {
			if (!this.institution) {
				return false
			}
			return this.appendToFilename(this.institution.image_url, '@2x')
		},
		...mapGetters(['isLoggedIn', 'cause'])
	},
	head: {
		title() {
			return {
				inner: this.title
			}
		},
		meta() {
			return [
				{ name: 'description', content: this.description },
				// Twitter
				{
					name: 'twitter:title',
					content: this.title,
					id: 'twitter_title'
				},
				{
					name: 'twitter:description',
					content: this.description,
					id: 'twitter_desc'
				},
				{
					name: 'twitter:image',
					content: this.image,
					id: 'twitter_image'
				},
				// Google+ / Schema.org
				{ itemprop: 'name', content: this.title, id: 'google_title' },
				{
					itemprop: 'description',
					content: this.description,
					id: 'google_desc'
				},
				{ itemprop: 'image', content: this.image, id: 'google_image' },
				// Facebook / Open Graph
				{ property: 'og:title', content: this.title, id: 'fb_title' },
				{
					property: 'og:description',
					content: this.description,
					id: 'fb_desc'
				},
				{ property: 'og:image', content: this.image, id: 'fb_image' }
			]
		}
	},
	methods: {
		...mapActions([
			'register',
			'getInstitution',
			'attachCard',
			'donateNow'
		]),
		...mapState({
			me: ({ me }) => me.current
		}),
		setGift(val) {
			this.gift = val
		},
		next() {
			this.current = 1
		},
		back() {
			this.current = 0
		},
		onDonateNow() {
			this.isLoading = true

			let amount = this.gift
			if (this.gift === 'custom') {
				amount = this.custom_gift
			}
			this.donateNow(amount)
				.then(() => {
					this.isLoading = false
					this.$swal(
						'Thanks',
						'You successfully donated $' +
							amount +
							'! Check your email for a confirmation.'
					)
					this.navigate({ name: 'home' }, 'forward')
					return
				})
				.catch(({ message, data }) => {
					this.isLoading = false
					let action = 'Retry Donation'
					if (!acceptibleErrors.includes(message)) {
						action = 'Add New Card'
					}

					this.$swal({
						title: 'Uh Oh!',
						text: message,
						showCancelButton: true,
						cancelButtonText: action,
						allowOutsideClick: false,
						allowEscapeKey: false
					}).then((result) => {
						if (result.value) {
							return
						}
						if (acceptibleErrors.includes(message)) {
							this.isLoading = true
							this.reprocessRoundup(data.payoutId).catch(
								(error) => {
									this.isLoading = false
									this.handleErrors(error.message)
								}
							)
						} else {
							this.navigate({ name: 'card' }, 'forward')
						}
					})
				})
		},
		onSubmit() {
			this.isLoading = true
			let amount = this.gift
			if (this.gift === 'custom') {
				amount = this.custom_gift
			}
			createToken(this.card, {
				name: this.user.first_name + this.user.last_name
			})
				.then((result) => {
					if (result.error) {
						this.isLoading = false
						this.$swal(result.error.message)
						return
					}
					window.analytics.track('deep_link_donate', {
						organization_id: this.institution.id,
						amount
					})
					this.handleRegister({
						token: result.token.id,
						amount
					}).catch((err) => {
						this.isLoading = false
						let message = err.message
						if (message.includes('already exists.')) {
							message =
								message +
								' Please log in to complete this transaction.'
						} else if (message.includes('spam accounts.')) {
							message =
								'We cannot process your donation with a spam email address. Please enter a valid eamil.'
						}
						this.$swal({
							title: 'Uh Oh!',
							text: message,
							showCancelButton:
								message.includes('already exists.'),
							cancelButtonText: 'Login',
							allowOutsideClick: false,
							allowEscapeKey: false
						}).then((result) => {
							if (result.value) {
								return
							}
							this.navigate(
								{ name: 'login', params: { redirect: 'home' } },
								'forward'
							)
							return
						})
					})
				})
				.catch((error) => {
					this.isLoading = false
					this.$swal(error.message)
				})
		},
		handleErrors() {
			this.$swal({
				title: 'Uh Oh!',
				text: 'Your donation failed twice with this card. We suggest adding a new one.',
				showCancelButton: true,
				cancelButtonText: 'Add New Card',
				allowOutsideClick: false,
				allowEscapeKey: false
			}).then((result) => {
				if (result.value) {
					return
				}
				this.navigate({ name: 'card' }, 'forward')
			})
		},
		handleRegister(params) {
			if (this.isLoggedIn) {
				return this.handleAttachCard(params)
			}
			return this.register(this.user).then(() =>
				this.handleAttachCard(params)
			)
		},
		handleAttachCard(params) {
			return this.attachCard(params)
				.then(() => {
					this.navigate(
						{ name: 'donate-success', params: { uuid: this.uuid } },
						'forward'
					)
				})
				.catch(({ message }) => {
					this.isLoading = false
					this.$swal(message)
				})
		},
		appendToFilename(filename, string) {
			var dotIndex = filename.lastIndexOf('.')
			if (dotIndex === -1) return filename + string
			else
				return (
					filename.substring(0, dotIndex) +
					string +
					filename.substring(dotIndex)
				)
		},
		downgradeImage(el) {
			el.srcElement.src = this.institution.image_url
		},
		onlyNumber(evt) {
			const clean = evt.replace(/\D+/g, '')
			if (clean !== evt) {
				this.message = 'Numbers only please :)'
			} else {
				this.message = null
			}
			this.user.phone = clean
		},
		onBack() {
			this.navigate({ name: this.backRoute }, 'back')
		}
	},
	mounted() {
		this.getInstitution(this.uuid)
			.then((institution) => {
				this.institution = institution
				this.noInstitution = false
				this.user.password =
					Math.random().toString(36).substring(2, 5) +
					Math.random().toString(36).substring(2, 9)

				// if (institution.fb_pixel_code) {
				//     facebook.boot(institution.fb_pixel_code)
				//     facebook.track('PageView')
				// }

				this.$emit('updateHead')
				loadScript('https://js.stripe.com/v3/').then(() => {
					this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY)
					this.stripe_token = process.env.VUE_APP_STRIPE_KEY
					this.stripeMounted = true
				})
			})
			.catch(() => {
				this.noInstitution = true
			})

		const urlParams = getUrlParams(window.location.href)
		if (urlParams.options) {
			this.options = urlParams.options.split(',')
			this.options.push('custom')
			this.gift = this.options[0]
		}

		if (this.cause.uuid !== this.uuid) {
			this.navigate({ name: 'home' }, 'forward')
		}
	}
}
</script>

<style lang="scss" scope>
.deep-donate-view {
	width: 960px;
	left: -240px;
	margin-top: 20px;
	text-align: left;
	position: absolute;
	@media screen and (max-width: 960px) {
		width: 100%;
		left: 0px;
	}
	@media screen and (max-width: 480px) {
		margin-top: 0px;
	}
	h1 {
		font-family: ff-tisa-web-pro, sans-serif;
		font-size: 42px;
		font-weight: 500;
		line-height: 48px;
		color: #111;
		margin: 15px 0px 10px;
	}
	h2 {
		font-family: ff-tisa-web-pro, sans-serif;
		font-size: 36px;
		font-weight: 500;
		line-height: 48px;
		color: #111;
		margin: 10px 0px;
	}
	h3 {
		font-family: objektiv-mk3, sans-serif;
		font-size: 22px;
		font-weight: 600;
		color: #111;
		margin: 10px 0px 0px;
	}
	p {
		font-family: objektiv-mk3, sans-serif;
		font-size: 18px;
		font-weight: 400;
		color: #111;
	}
	.powered-by-logo {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		margin-bottom: 10px;
		text-align: center;
		p {
			color: $dark-gray;
			font-size: 12px;
			line-height: 10px;
		}
	}
	.deep-register-parts {
		display: flex;
		justify-content: center;
		@media screen and (max-width: 960px) {
			display: block;
		}
	}
	.register-images {
		position: relative;
		margin-left: -40px;
		margin-right: -40px;
		margin-top: -30px;
		height: 275px;
		overflow: hidden;
		.cover {
			height: 100%;
			max-width: 100%;
			-o-object-fit: contain;
			object-fit: contain;
			width: 100%;
		}
		img {
			border-radius: 10px 10px 0px 0px;
			width: 100%;
			@media screen and (max-width: 480px) {
				border-radius: 0px;
			}
		}
		.logo {
			max-width: 75px;
			position: absolute;
			left: 40px;
			bottom: 15px;
			border-radius: 10px;
		}
	}

	.donate {
		color: #fff;
		position: relative;
		overflow: hidden;
		flex-direction: row;
		display: flex;
		width: 100%;
		min-height: 250px;
		.section {
			&.active {
				display: block;
				width: 100%;
			}
			&.inactive {
				display: none;
			}
		}
	}

	.deep-register-half {
		padding: 0px 15px;
	}
	.deep-register-emotion {
		background: #fff;
		border-radius: 10px;
		box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
		padding: 30px 40px;
		width: 60%;
		flex-shrink: 0;
		@media screen and (max-width: 960px) {
			width: auto;
		}
		@media screen and (max-width: 480px) {
			border-radius: 0px;
		}
		.register-form {
			label {
				display: block;
				margin-top: 5px;
				margin-bottom: 5px;
			}
			.terms {
				font-size: 14px;
				color: #888;
				margin-bottom: 0px;
			}
			.stripe-card {
				width: 300px;
				border: 1px solid #808080;
				background: $input-grey;
				border-width: 0px;
				width: 100%;
				font-size: $font-size;
				padding: 20px 15px;
				outline: none;
				-webkit-appearance: none;
				appearance: none;
				border-radius: 10px;
				&.complete {
					border-color: #008000;
				}
				&::placeholder {
					color: $medium-grey;
				}
			}
		}
	}

	.deep-register-steps {
		padding: 30px 10px 30px 30px;
		@media screen and (max-width: 480px) {
			padding: 30px;
		}
		.step {
			.columns {
				display: flex;
			}
			p {
				margin-top: 5px;
			}
			img {
				width: 25%;
				height: 25%;
			}
		}
	}
	.roundup-button {
		width: auto;
		background: #184fd5;
		color: #fff;
		border-radius: 20px;
		cursor: pointer;
		display: inline-block;
		font-family: objektiv-mk3, sans-serif;
		font-size: 14px;
		font-weight: 600;
		padding: 10px 20px;
		margin-top: 20px;
		position: relative;
		text-decoration: none;
	}
}
</style>
